/** @file toBabylonVec3: a z-up world point in Babylon's left-handed y-up scene, (x, y, z) -> (x, z, y). */
import { Vector3 } from '@babylonjs/core/Maths/math.vector.js';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `(x, y, z) -> (x, z, y)`: world z (up) is Babylon y, world y (north, into the screen at yaw 0) is Babylon z. */
export function toBabylonVec3(p: Vec3, out: Vector3 = new Vector3()): Vector3 {
  return out.set(p[0], p[2], p[1]);
}
